(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define(['exports', 'react', 'lodash.noop', 'lodash.omit'], factory);
    } else if (typeof exports !== "undefined") {
        factory(exports, require('react'), require('lodash.noop'), require('lodash.omit'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.react, global.lodash, global.lodash);
        global.TreeNode = mod.exports;
    }
})(this, function (exports, _react, _lodash, _lodash3) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _react2 = _interopRequireDefault(_react);

    var _lodash2 = _interopRequireDefault(_lodash);

    var _lodash4 = _interopRequireDefault(_lodash3);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }

        return target;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var TreeNode = function (_React$Component) {
        _inherits(TreeNode, _React$Component);

        /* istanbul ignore next */
        function TreeNode(props) {
            _classCallCheck(this, TreeNode);

            var _this = _possibleConstructorReturn(this, (TreeNode.__proto__ || Object.getPrototypeOf(TreeNode)).call(this, props));

            _this.state = _this._getInitialState();

            _this.onActiveNodeChanged = _this.onActiveNodeChanged.bind(_this);

            _this.deferAnimateChildrenInvisibleDuration = 100;
            return _this;
        }

        _createClass(TreeNode, [{
            key: '_getInitialState',
            value: function _getInitialState() {
                var _props = this.props,
                    verticalAnimationConfig = _props.verticalAnimationConfig,
                    shouldShowAllNodes = _props.shouldShowAllNodes;

                var defaultConfig = TreeNode.defaultProps.verticalAnimationConfig;
                var config = Object.assign({}, defaultConfig, verticalAnimationConfig);
                var transitionValue = 'height ' + config.durationInMs + 'ms ' + config.timing;
                var height = shouldShowAllNodes ? 'auto' : '0px';

                return {
                    childrenContainerStyle: {
                        height: height,
                        overflow: 'hidden',
                        transition: transitionValue,
                        WebkitTransition: transitionValue
                    }
                };
            }
        }, {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                var hasActiveNodeChanged = nextProps.activePath !== this.props.activePath;

                if (!hasActiveNodeChanged || !this.isBranchNode()) {
                    return;
                }

                if (this.isActiveNode(nextProps) && !this.areChildrenVisbile()) {
                    this.animateChildrenVisible();
                } else if (!this.isOnActivePath(nextProps) && this.areChildrenVisbile()) {
                    this.animateChildrenInvisible();
                }
            }
        }, {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!this.isBranchNode()) {
                    return;
                }

                if (this.isOnActivePath(this.props)) {
                    this.setChildrenVisible();
                }
            }
        }, {
            key: 'onActiveNodeChanged',
            value: function onActiveNodeChanged(e) {
                e.stopPropagation();

                var _props2 = this.props,
                    currentPath = _props2.currentPath,
                    depth = _props2.depth,
                    index = _props2.index,
                    node = _props2.node;

                this.props.onActiveNodeChanged(e, node, depth, index, currentPath);
            }
        }, {
            key: 'render',
            value: function render() {
                if (this.isRootNode()) {
                    return this.getRootNode();
                }

                if (this.isBranchNode()) {
                    return this.getBranchNode();
                }

                return this.getLeafNode();
            }
        }, {
            key: 'getRootNode',
            value: function getRootNode() {
                var _props3 = this.props,
                    depth = _props3.depth,
                    mapListClassName = _props3.mapListClassName,
                    node = _props3.node;


                return _react2.default.createElement(
                    'ul',
                    { className: mapListClassName({ depth: depth, isOnActivePath: true, node: node }) },
                    this.getChildNodes(Object.assign({}, (0, _lodash4.default)(this.props, 'node'), { nodes: node }))
                );
            }
        }, {
            key: 'getBranchNode',
            value: function getBranchNode() {
                var _this2 = this;

                var _props4 = this.props,
                    childrenPropertyName = _props4.childrenPropertyName,
                    depth = _props4.depth,
                    index = _props4.index,
                    mapListClassName = _props4.mapListClassName,
                    mapListItemClassName = _props4.mapListItemClassName,
                    mapNodeContent = _props4.mapNodeContent,
                    node = _props4.node,
                    shouldLazyRender = _props4.shouldLazyRender,
                    shouldShowAllNodes = _props4.shouldShowAllNodes;


                var isOnActivePath = this.isOnActivePath(this.props);
                var isActiveNode = this.isActiveNode(this.props);
                var shouldRenderChildren = isOnActivePath || !shouldLazyRender || this.hasRenderedChildren() || shouldShowAllNodes;

                return _react2.default.createElement(
                    'li',
                    {
                        className: mapListItemClassName({
                            depth: depth,
                            isActiveNode: isActiveNode,
                            isLeafNode: false,
                            isOnActivePath: isOnActivePath,
                            node: node
                        }),
                        onClick: this.onActiveNodeChanged
                    },
                    mapNodeContent({
                        depth: depth,
                        index: index,
                        isActiveNode: isActiveNode,
                        isLeafNode: false,
                        isOnActivePath: isOnActivePath,
                        node: node
                    }),
                    shouldRenderChildren && _react2.default.createElement(
                        'div',
                        { style: this.state.childrenContainerStyle },
                        _react2.default.createElement(
                            'ul',
                            {
                                className: mapListClassName({
                                    depth: depth + 1,
                                    isOnActivePath: isOnActivePath,
                                    node: node
                                }),
                                ref: function ref(el) {
                                    _this2.el = el;
                                }
                            },
                            this.getChildNodes(Object.assign({}, this.props, {
                                depth: depth + 1,
                                nodes: node[childrenPropertyName]
                            }))
                        )
                    )
                );
            }
        }, {
            key: 'getLeafNode',
            value: function getLeafNode() {
                var _props5 = this.props,
                    depth = _props5.depth,
                    index = _props5.index,
                    mapListItemClassName = _props5.mapListItemClassName,
                    mapNodeContent = _props5.mapNodeContent,
                    node = _props5.node;


                var isActiveNode = this.isActiveNode(this.props);
                var isOnActivePath = isActiveNode;
                var isLeafNode = true;

                return _react2.default.createElement(
                    'li',
                    {
                        className: mapListItemClassName({
                            depth: depth,
                            isActiveNode: isActiveNode,
                            isLeafNode: isLeafNode,
                            isOnActivePath: isOnActivePath,
                            node: node
                        }),
                        onClick: this.onActiveNodeChanged
                    },
                    mapNodeContent({
                        depth: depth,
                        index: index,
                        isActiveNode: isActiveNode,
                        isLeafNode: isLeafNode,
                        isOnActivePath: isOnActivePath,
                        node: node
                    })
                );
            }
        }, {
            key: 'getChildNodes',
            value: function getChildNodes(props) {
                var _this3 = this;

                var currentPath = props.currentPath,
                    nodes = props.nodes;

                return nodes.map(function (node, index) {
                    var newPath = _this3.getNewPath(currentPath, index);
                    return _react2.default.createElement(TreeNode, _extends({}, props, {
                        index: index,
                        node: node,
                        currentPath: newPath,
                        key: index
                    }));
                });
            }
        }, {
            key: 'setChildrenContainerHeight',
            value: function setChildrenContainerHeight(height, cb) {
                this.setState({
                    childrenContainerStyle: Object.assign({}, this.state.childrenContainerStyle, { height: '' + height })
                }, cb);
            }
        }, {
            key: 'setChildrenVisible',
            value: function setChildrenVisible() {
                this.setChildrenContainerHeight('auto');
            }
        }, {
            key: 'animateChildrenVisible',
            value: function animateChildrenVisible() {
                var _this4 = this;

                setTimeout(function () {
                    _this4.setChildrenContainerHeight(_this4.el.clientHeight + 'px');
                    setTimeout(function () {
                        _this4.setChildrenContainerHeight('auto');
                    }, _this4.props.verticalAnimationConfig.durationInMs);
                }, 0);
            }
        }, {
            key: 'animateChildrenInvisible',
            value: function animateChildrenInvisible() {
                var _this5 = this;

                this.setChildrenContainerHeight(this.el.clientHeight + 'px');
                setTimeout(function () {
                    _this5.setChildrenContainerHeight('0px');
                }, this.deferAnimateChildrenInvisibleDuration);
            }
        }, {
            key: 'isOnActivePath',
            value: function isOnActivePath(props) {
                var activePath = props.activePath,
                    currentPath = props.currentPath,
                    depth = props.depth;

                var ap = this.getPathAtDepth(activePath, depth);
                var cp = this.getPathAtDepth(currentPath, depth);

                return ap === cp;
            }
        }, {
            key: 'getNewPath',
            value: function getNewPath(currentPath, index) {
                return '' + currentPath + (currentPath ? ',' : '') + index;
            }
        }, {
            key: 'getPathAtDepth',
            value: function getPathAtDepth(path, depth) {
                return path.split(',').slice(0, depth + 1).join();
            }
        }, {
            key: 'isRootNode',
            value: function isRootNode() {
                return Array.isArray(this.props.node);
            }
        }, {
            key: 'isBranchNode',
            value: function isBranchNode() {
                var _props6 = this.props,
                    node = _props6.node,
                    childrenPropertyName = _props6.childrenPropertyName;

                return this.hasChildren(node, childrenPropertyName);
            }
        }, {
            key: 'isActiveNode',
            value: function isActiveNode(props) {
                var activePath = props.activePath,
                    currentPath = props.currentPath;


                return activePath === currentPath;
            }
        }, {
            key: 'hasChildren',
            value: function hasChildren(node, childrenPropertyName) {
                return !!(node[childrenPropertyName] && node[childrenPropertyName].length);
            }
        }, {
            key: 'hasRenderedChildren',
            value: function hasRenderedChildren() {
                return !!this.el;
            }
        }, {
            key: 'areChildrenVisbile',
            value: function areChildrenVisbile() {
                return this.state.childrenContainerStyle.height !== '0px';
            }
        }]);

        return TreeNode;
    }(_react2.default.Component);

    TreeNode.displayName = 'TreeNode';

    TreeNode.defaultProps = {
        depth: 0,
        childrenPropertyName: 'children',
        currentPath: '',
        mapListClassName: _lodash2.default,
        mapListItemClassName: _lodash2.default,
        mapNodeContent: _lodash2.default,
        onActiveNodeChanged: _lodash2.default,
        shouldLazyRender: true,
        shouldShowAllNodes: false,
        verticalAnimationConfig: {
            durationInMs: 300,
            timing: 'ease-in'
        }
    };

    exports.default = TreeNode;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-lazy-tree/dist/TreeNode.js
// module id = 373
// module chunks = 0